"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTakeover = addTakeover;
exports.modalSetter = modalSetter;
exports.onConfigure = onConfigure;
exports.default = exports.observer = exports.OBSERVER_DEFAULT_SELECTORS = void 0;

var _runtimeDeferred = require("../runtimeDeferred");

var _shared = require("@exc/shared");

var _util = require("../util");

var _Messenger = require("../Messenger");

var _config = require("../config");

let configuration;
const OBSERVER_DEFAULT_SELECTORS = ['[role="dialog"]'];
exports.OBSERVER_DEFAULT_SELECTORS = OBSERVER_DEFAULT_SELECTORS;
let observerSelectors = OBSERVER_DEFAULT_SELECTORS;

function addTakeover() {
  if (document.getElementById('shell-placeholder')) {
    return;
  }

  const div = document.createElement('div');
  div.id = 'shell-placeholder';
  document.body.insertBefore(div, document.body.childNodes[0]);

  _Messenger.messenger.send(_shared.Events.CAN_TAKEOVER, {});
}
/**
 * Callback used by modalAutoDetect's mutation observer.
 * @param mutation A MutationRecord from a mutaton observer
 * @param enable If true, checks for addedNodes and sets page.modal = true,
 * if false, checks for removedNodes and set page.modal = false.
 */


function modalSetter(mutation, enable) {
  mutation[enable ? 'addedNodes' : 'removedNodes'].forEach(node => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const allSelectors = page.getModalQuerySelectors().join(',');
    const el = node;
    let allModalMatches = el.querySelectorAll(allSelectors);

    if (allModalMatches.length > 0 || el.matches(allSelectors)) {
      page.modal = enable;
    }
  });
} // Setup the mutation observer to use with modalAutoDetect when turned on


const observer = new MutationObserver(function (mutationsList) {
  for (const mutation of mutationsList) {
    modalSetter(mutation, true);
    modalSetter(mutation, false);
  }
});
exports.observer = observer;
const page = {
  blockNavigation: (enabled, options) => {
    _Messenger.messenger.send(_shared.Events.BLOCK_NAVIGATION, {
      enabled,
      options
    });
  },
  clipboardWrite: msg => {
    _Messenger.messenger.send(_shared.Events.CLIPBOARD_WRITE, {
      msg
    });
  },
  done: () => {
    _runtimeDeferred.engine.done(performance.now());
  },
  generateShellUrl: (location, newApp) => {
    return (0, _util.generateShellUrl)(configuration, location, newApp);
  },
  getModalQuerySelectors: () => observerSelectors && observerSelectors.length ? observerSelectors : OBSERVER_DEFAULT_SELECTORS,
  iframeReload: cacheBust => {
    cacheBust = cacheBust === undefined ? !configuration.spaAppId : cacheBust;

    _Messenger.messenger.send(_shared.Events.IFRAME_RELOAD, {
      cacheBust
    });
  },
  notFound: () => {
    _Messenger.messenger.send(_shared.Events.NOT_FOUND, {});
  },
  openInNewTab: (path, newApp) => {
    window.open(page.generateShellUrl({
      path
    }, newApp));
  },
  setModalQuerySelectors: selectors => {
    observerSelectors = selectors;
  },
  shellRedirect: (path, options) => _Messenger.messenger.send(_shared.Events.SHELL_REDIRECT, { ...options,
    path
  })
};

function onConfigure(config) {
  configuration = config;
}

(0, _config.setupConfig)(page, ['appContainer', 'favicon', 'modal', 'modalAutoDetect', 'preventDefaultCombos', 'spinner', 'title', 'unloadPromptMessage'], (apiName, value) => {
  if (value && apiName === 'appContainer') {
    addTakeover();
  }

  if (apiName === 'modalAutoDetect') {
    if (value) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      observer.disconnect();
    }
  }
});
var _default = page;
exports.default = _default;